const style = {
  root: {
  }
}

export default style